<template>
  <div class="grid grid-cols-12">
    <div class="col-span-12 md:col-span-4">
      <div class="hidden md:block mb-5 text-center">
        <h1 class="font-bold text-3xl truncate">{{ artist.full_name }}</h1>
        <a v-show="isAdmin" class="text-sm" :href="`/admin/artists/${artist.id}`" target="_blank"> (edit) </a>
      </div>

      <div class="w-[190px] m-auto relative flex">
        <img class="rounded-full align-middle" :src="artist.artist_photo_url" />
        <Badges :artist="artist" />
      </div>

      <div class="block md:hidden mt-20 pl-0 pr-0 text-center">
        <h1 class="font-bold text-3xl truncate">{{ artist.full_name }}</h1>
      </div>
      <div class="text-sm mt-24 md:mt-10 leading-7 text-center text-slate-700">
        <div>
          <span v-if="artist.featured || artist.featured_at">Featured artist,</span>
          {{ artist.location }}
        </div>
        <div class="mt-3 text-sm text-grey-dark">
          <ArtistSocialStats :artist="artist" />
        </div>
        <div class="mt-3 text-sm" v-if="artist.galleries.length > 0">
          <span class="mr-3" v-for="gallery in artist.galleries">
            <a :href="gallery.url">{{ gallery.name }}</a>
          </span>
        </div>
        <div class="mt-8 flex justify-between">
          <ArtistFollowButton class="w-1/2" />
          <SocialShare
            title="Artist Profile"
            :facebook="artist.share.facebook"
            :pinterest="artist.share.pinterest"
            :twitter="artist.share.twitter"
            :email="artist.share.email"
            :url="artist.profile_url"
          />
        </div>
      </div>
      <div class="mt-10">
        <ArtistPrizes class="mb-8" :artist="artist" per="2" v-if="artist.prizes.length > 0" />

        <div class="ArtistAbout-Bio" v-html="artist.bio"></div>
        <a class="AboutLink" href="" @click.prevent="setTab('bio')">Read More</a>
      </div>
      <div class="mt-10">
        <a
          :href="artist.conversation_path"
          data-toggle="modal"
          data-target="#conversation-modal"
          data-remote="true"
          class="leading-7 tracking-[2px] text-xs font-bold py-7 w-full mt-8 btn btn-outline-blue text-uppercase"
        >
          Ask about a Commission
        </a>
      </div>
    </div>
    <div class="col-span-12 md:col-span-8 mt-10 md:mt-0 w-full pl-0 md:pl-28">
      <ArtistSliders :artist="artist" />
    </div>
  </div>
</template>

<script setup>
import ArtistSliders from "./ArtistSliders.vue"
import ArtistPrizes from "./ArtistPrizes.vue"
import ArtistFollowButton from "./ArtistFollowButton.vue"
import ArtistSocialStats from "./ArtistSocialStats.vue"
import Badges from "./Badges.vue"
import SocialShare from "./SocialShare.vue"

import { inject } from "vue"

const artist = inject("artist")
const isAdmin = inject("isAdmin")
const setTab = inject("setTab")
</script>

<style lang="scss" scoped>
:deep(.SocialShareBtn) {
  height: 55px;

  .fa-paper-plane {
    margin-left: 0;
  }
}
:deep(.ArtistFollowButton-Follow) {
  height: 55px;
}
</style>
